<template>
  <div
    class="align-center justify-center"
    eager
    contained
    persistent
  >
    <!-- 전달할 북마크 클릭 시 북마크 정보 모달창 -->
    <v-card
      v-if="userEmailStore.isShowBookmark"
      id="showBookmark"
      width="700"
      min-width="0"
      :max-width="`${95*props.vw}px`"
    >
      <v-card-text>
        <div
          class="w-100 h-100 d-flex flex-column align-center justify-center pa-4"
          style="border-radius: 16px; background: #f6f6f6;"
        >
          <v-img
            :key="userEmailStore.scrap.scrapSeq"
            :src="bookmarkBlobSrc(userEmailStore.emailBookmarkImageUrl)"
            width="100%"
            max-height="500"
            class="bookmark-img"
            :eager="true"
          >
            <template #placeholder>
              <v-row
                class="fill-height fill-width ma-0"
                align="center"
                justify="center"
                style="min-height: 100px;"
              >
                <v-progress-circular
                  indeterminate
                  color="primary"
                />
              </v-row>
            </template>
          </v-img>

          <div class="w-100 bmk">
            <p class="bmk_pg">
              <span>{{ userEmailStore.scrap.serial?.substring(12, 15) }}면</span>
            </p>
            <p class="bmk_tit">
              {{ userEmailStore.scrap.title }}
            </p>
            <p class="bmk_date">
              <span>발행일 : {{ userEmailStore.scrap.newsDate }}</span>
              <span>북마크일 : {{ userEmailStore.scrap.regDate }}</span>
            </p>
          </div>
        </div>
      </v-card-text>
    </v-card>

    <!-- 주소록 버튼 클릭 시 주소설정 모달창 -->
    <v-card
      v-if="!userEmailStore.isShowBookmark"
      id="editAddress"
      width="400"
      min-width="0"
      :max-width="`${95 * props.vw}px`"
    >
      <div
        class="mt-2 py-2 d-flex align-center justify-space-between "
        style="overflow: hidden;"
      >
        <v-card-title class="py-0 my-0 ps-5 pe-0">
          메일 주소록
        </v-card-title>
        <!-- 메일 검색창 -->
        <div
          :style="{ width: mobile ? '190px' : '190px' }"
          class="ms-4"
        >
          <v-text-field
            v-model="searchText"
            placeholder="이메일 검색"
            class="no-input-border email-search"
            style="font-size: 16px;"
            variant="outlined"
            density="compact"
            hide-details
            single-line
            @keyup.enter="searchClick_emailBook()"
            @focus="userEmailStore.$changeFocusingState(true)"
            @blur="userEmailStore.$changeFocusingState()"
          >
            <template #append-inner>
              <v-btn
                icon="mdi-magnify"
                variant="text"
                size="small"
                @click.stop="searchClick_emailBook()"
              />
            </template>
          </v-text-field>
        </div>
        <!-- 주소 추가 버튼 -->
        <v-tooltip
          location="start"
          transition="null"
          opacity="0"
          offset="7"
          width="85"
          :disabled="userJS.isHandheldDevice()"
        >
          <template #activator="{ props: tooltip }">
            <v-btn
              class="ms-2 me-4"
              style="width: 40px; min-width: 32px; min-height: 32px;"
              variant="flat"
              color="#CDD3D9"
              :ripple="false"
              v-bind="tooltip"
              @click="setAddressOverlay();"
            >
              <v-icon style="transform: scaleX(-1);">
                mdi-account-plus
              </v-icon>
            </v-btn>
          </template>
          <!-- 툴팁 내용 -->
          <div
            class="text-caption d-flex align-center"
          >
            주소 추가하기
          </div>
        </v-tooltip>
      </div>

      <v-card-text class="pt-0 pb-2 px-2 px-4">
        <div
          class="d-flex flex-column input-border-effect"
          style="height: 350px; overflow-y: auto;"
        >
          <div class="pa-2 d-flex align-center">
            <label
              class="cursor-pointer"
              style="font-size: 16px; user-select: none;"
            >
              <input
                v-model="userEmailStore.isTotal"
                class="mb-1"
                style="accent-color: #3182f6;"
                type="checkbox"
              >
              전체
            </label>
          </div>
          <v-divider />
          <v-list
            v-if="userEmailStore.copiedEmailData?.length"
            id="emailList"
            density="compact"
            nav
            lines="one"
            class="h-100 scroll-container6"
            style="overflow: hidden auto;"
          >
            <!-- 결과 없음 메시지 -->
            <div
              v-if="!isViewAll && !isSearchResultExist"
              class="pa-4 text-grey text-center w-100"
            >
              검색 결과가 없습니다.
            </div>

            <!-- 이메일 목록 렌더링 -->
            <v-list-item
              v-for="(email, index) in filteredCopiedEmailData"
              :id="'email-list-' + index"
              :key="index"
              :value="email.addressSeq"
              :ripple="false"
              class="email-list-item w-100 cursor-pointer"
              @click.stop="toggleCheckbox(email, index);"
            >
              <div class="d-flex align-center justify-space-between w-100">
                <div
                  class="d-flex align-center"
                  style="width: 100%; max-width: calc(100% - 85px);"
                >
                  <input
                    v-model="email.isSelected"
                    class="mb-1"
                    style="accent-color: #3182f6; margin-right: 6px;"
                    type="checkbox"
                  >
                  <label
                    class="cursor-pointer"
                    style="font-size: 14px; width: 100%; user-select: none;"
                    @click.stop="toggleCheckbox(email, index);"
                  >
                    <span v-if="!mobile">
                      {{ `${email.alias} <"${email.address}">` }}
                    </span>
                    <span v-else>
                      <span v-if="email.alias">{{ email.alias }}<br></span>
                      {{ `<"${email.address}">` }}
                    </span>
                  </label>
                </div>

                <div
                  class="ms-2"
                  style="width: 50px; min-width: 50px; height: 33px; overflow: hidden;"
                >
                  <v-btn
                    style="width: 100%; min-width: 100%; height: 100%; min-height: 100%; padding: 0px 8px; font-size: 14px;"
                    :ripple="false"
                    variant="flat"
                    color="primary"
                    :disabled="isInDeleteProgress"
                    @click.stop="removeAddress(email.addressSeq);"
                  >
                    {{ '삭제' }}
                  </v-btn>
                </div>
              </div>
            </v-list-item>
          </v-list>
        </div>

        <div
          class="d-flex flex-column"
          style="height: 150px; overflow-y: auto;"
        >
          <div
            class="pt-2 pb-1 px-2"
            style="font-size: 16px;"
          >
            받는 사람
          </div>
          <div
            id="selectedEmailList"
            class="h-100 input-border-effect scroll-container7"
            style="overflow: hidden auto;"
          >
            <v-container class="py-5">
              <v-row
                align="center"
                justify="start"
              >
                <v-col
                  v-for="(selection, i) in userEmailStore.copiedSelectedEmailList_arr"
                  :key="i+'-'+selection.address"
                  class="py-1 ps-2 pe-0"
                  cols="1"
                  style="max-width: 80%;"
                >
                  <v-chip
                    :id="'selected-email-list-' + i"
                    size="small"
                    variant="tonal"
                    :color="selection.isSaved ? 'primary' : 'green'"
                    closable
                    class="overflow-hidden"
                    :class="selection.isSaved ? 'selected-saved-address-chip' : 'selected-unsaved-address-chip'"
                    @click:close="toggleCheckbox(selection, i, true);"
                  >
                    <span
                      class="text-truncate"
                      style="display: inline-block; max-width: 200px;"
                    >
                      {{ selection.alias ? `${selection.alias} <"${selection.address}">` : `<"${selection.address}">` }}
                    </span>
                  </v-chip>
                </v-col>
              </v-row>
            </v-container>
          </div>
        </div>

        <v-card-actions
          id="save-keyword-btn"
          class="px-0 py-2"
        >
          <v-btn
            color="surface-variant"
            variant="flat"
            :ripple="false"
            @click="closeEmailOverlay();"
          >
            취소
          </v-btn>
          <v-spacer />
          <v-btn
            color="primary"
            variant="flat"
            :ripple="false"
            @click="applySelection();"
          >
            확인
          </v-btn>
        </v-card-actions>
      </v-card-text>
    </v-card>

    <!-- 두 번째 모달 : 이메일 주소 추가 창 -->
    <v-overlay
      v-model="isAddAddressOverlayOn"
      class="d-flex align-center justify-center"
      eager
      :style="{
        width: `${Math.min(450, 85 * props.vw)}px`,
        minWidth: '0',
        margin: '40px auto'
      }"
    >
      <v-card
        id="addAddress"
        width="350"
        min-width="0"
        :max-width="`${85*props.vw}px`"
      >
        <v-card-title>
          이메일 주소 추가
        </v-card-title>
        <v-card-text class="py-2 px-4">
          <div class="d-flex align-center justify-space-between pa-2">
            <div>이름</div>
            <input
              v-model="newAlias"
              type="text"
              maxlength="200"
              hide-details
              class="ms-4 input-border-effect"
              style="width: 70%; min-height: 40px; padding: 8px 4px 8px 12px; font-size: 16px;"
            >
          </div>
          <div class="d-flex align-center justify-space-between pa-2">
            <div>주소</div>
            <div style="width: 70%; min-height: 40px;">
              <input
                v-model="newAddress"
                type="text"
                placeholder="example@domain.com"
                class="input-border-effect"
                style="width: 100%; padding: 8px 4px 8px 12px;"
                :class="{ 'invalid-address-input': !isValidEmail }"
                hide-details
                @input="isValidEmail = userEmailStore.$isValidEmail(newAddress);"
              >
              <span
                v-if="!isValidEmail"
                class="invalid-address-error-text"
              >이메일 형식이 아닙니다.</span>
            </div>
          </div>
          <v-card-actions class="pt-4 pb-2 px-0">
            <v-btn
              color="surface-variant"
              variant="flat"
              :ripple="false"
              @click="setAddressOverlay(false);"
            >
              취소
            </v-btn>
            <v-spacer />
            <v-btn
              color="primary"
              variant="flat"
              :ripple="false"
              @click="addAddress();"
            >
              저장
            </v-btn>
          </v-card-actions>
        </v-card-text>
      </v-card>
    </v-overlay>
  </div>
</template>

<script setup>
  import axios from 'axios';
  import { ref, computed, watch, nextTick, reactive, onBeforeUnmount  } from "vue";
  import { useDisplay } from 'vuetify'
  const { mobile } = useDisplay();

  import { useUserAlertStore, useUserEmailStore } from '@/store';
  import { commonJS, userJS } from "@/assets/js";
  const userEmailStore = useUserEmailStore();
  const userAlertStore = useUserAlertStore();

  const props = defineProps({
    vw: Number,
  });
  // const $emit = defineEmits(['']);

  /**
   * 주소록 - 검색 기능
   */
  const searchText = ref('');
  const isViewAll = ref(true); // 전체 목록 보여주기 여부
  const isSearchResultExist = ref(true); // 검색 결과 있는지 여부
  const filteredCopiedEmailData = computed(() => { // isViewAll.value와 isSearchResultExist.value에 따라 주소록 전체 목록 또는 검색 결과를 반환
    if (isViewAll.value) return userEmailStore.copiedEmailData;
    if (!isSearchResultExist.value) return [];
    return userEmailStore.copiedEmailData.filter(email => email.isSearched);
  });
  // 검색 대상이 되는 모든 이메일 목록 반환
  const allAddressList_emailBook = computed(()=>{
    let dataList = userEmailStore.emailData?.map(email=> `${email.alias} <"${email.address}">`);
    return dataList || [];
  })
  // 검색 기능
  function searchClick_emailBook(){
    let searchTerm = searchText.value.trim();
    if(!searchTerm) { // 검색창 빈칸으로 검색 시 -> 전체 목록 불러오도록
      isViewAll.value = true;
      return;
    }

    let resultArr = userEmailStore.copiedEmailData.filter(email => `${email.alias} <${email.address}>`.includes(searchTerm));
    if(resultArr.length == 0) { // 검색 결과 없을 시 -> 전체 목록 불러오도록
      isViewAll.value = false;
      isSearchResultExist.value = false;
      return;
    }
    userEmailStore.copiedEmailData.forEach((email, idx) => {
      let condition = resultArr.some(result => result.addressSeq == email.addressSeq);
      userEmailStore.copiedEmailData[idx].isSearched = condition;
    })
    isViewAll.value = false;
    isSearchResultExist.value = true;
  }

  /**
   * 주소록 - '전체' 체크박스 클릭 기능
   */
  watch(()=>userEmailStore.isTotal, (newVal)=>{
    let unsavedEmailsArr = [];
    if(newVal) {
      if(userEmailStore.isAlreadyALLSelected) return;  // toggleCheckbox()에 의해 직접 다 클릭한 상태일 때 -> userEmailStore.copiedSelectedEmailList_arr 요소의 순서가 바뀌지 않도록...
      unsavedEmailsArr = userEmailStore.copiedSelectedEmailList_arr.filter(email => !email.isSaved);
      userEmailStore.copiedEmailData.forEach(email=>email.isSelected = true);

      userEmailStore.copiedSelectedEmailList_arr = JSON.parse(JSON.stringify([...unsavedEmailsArr, ...userEmailStore.copiedEmailData]));
      userEmailStore.isAlreadyALLSelected = true;
    } else {
      if(!userEmailStore.isAlreadyALLSelected) return;  // toggleCheckbox()에 의해 직접 다 클릭 해제 상태일 때 -> userEmailStore.copiedSelectedEmailList_arr 요소의 순서가 바뀌지 않도록...
      unsavedEmailsArr = userEmailStore.copiedSelectedEmailList_arr.filter(email => !email.isSaved);
      userEmailStore.copiedEmailData.forEach(email=>email.isSelected = false);
      userEmailStore.copiedSelectedEmailList_arr = JSON.parse(JSON.stringify(unsavedEmailsArr));
      userEmailStore.isAlreadyALLSelected = false;
    }
  })

  /**
   * 주소록 : 주소 체크박스 클릭 기능
   */
  function toggleCheckbox(email, index, isChip=false) {         // by 상단 주소 목록에서 체크박스 클릭 or by 하단 받는 사람 목록에서 삭제버튼 클릭
    let prevLength = userEmailStore.copiedSelectedEmailList_arr.filter(email=>email.isSaved == true).length; // toggle 전 선택된 주소들 중에 주소록에 저장된 것 구하기.

    const all_index = userEmailStore.copiedEmailData.findIndex(c => c.address == email.address);
    const selected_index = userEmailStore.copiedSelectedEmailList_arr.findIndex(selection => email.address == selection.address);

    if (selected_index == -1) {
      userEmailStore.copiedSelectedEmailList_arr.push(email);
      if(all_index != -1) { // 주소록에 저장된 주소만 영향받도록.
        userEmailStore.copiedEmailData[all_index].isSelected = true;
      }
    } else {
      userEmailStore.copiedSelectedEmailList_arr.splice(selected_index, 1);
      if(all_index != -1) { // 주소록에 저장된 주소만 영향받도록.
        userEmailStore.copiedEmailData[all_index].isSelected = false;
      }
    }

    if(all_index == -1) return; // 주소록에 저장된 주소가 아닌 수동 저장된 주소라면!

    if(!isChip) {
      userJS.moveElementPosition('scroll-container6', 'email-list-' + index);
    } else {
      userJS.moveElementPosition('scroll-container7', 'selected-email-list-' + index);
    }

    // 직접 다 클릭한 경우 =================================================
    let emailDataLength = userEmailStore.copiedEmailData.length;
    if(!emailDataLength) return;
    let selectedDataLength = userEmailStore.copiedSelectedEmailList_arr.filter(email=>email.isSaved == true).length; // toggle 후 선택된 주소들 중에 주소록에 저장된 것 구하기.
    // 1. 전체 선택 해제한 경우
    if(prevLength == emailDataLength && selectedDataLength < prevLength){
      userEmailStore.isAlreadyALLSelected = false;
      userEmailStore.isTotal = false; // userEmailStore.isTotal를 watch로 감시하는 코드로 이동!
    }
    // 2. 전체 선택한 경우
    if(selectedDataLength == emailDataLength && selectedDataLength > prevLength) {
      userEmailStore.isAlreadyALLSelected = true;
      userEmailStore.isTotal = true; // userEmailStore.isTotal를 watch로 감시하는 코드로 이동!
    }
    // ====================================================================
  }

  /**
   * 주소록 : 이메일 주소 바로 생성하는 모달창 기능
   */
  const isAddAddressOverlayOn = ref(false);
  const newAlias = ref('');
  const newAddress = ref('');
  const isValidEmail = ref(true);
  async function addAddress(){
    if(newAddress.value.trim('') == ''){
      alert('추가할 이메일 주소를 입력해주세요.');
      return;
    }
    if (!isValidEmail.value) {
      alert('올바른 이메일 주소 형식이 아닙니다.\n올바른 형식 예: example@domain.com');
      return;
    }

    // 기존 켜져있던 모든 alert창 끄기
    userAlertStore.$resetAllAlert();

    newAlias.value = newAlias.value.split(' ').filter(Boolean).join(' '); // 이메일 이름 : 공백이 둘 이상이면 하나로 여기도록.
    newAddress.value = newAddress.value.split(' ').join(''); // 이메일 주소 : 공백이 있으면 없애도록.

    try {
      let params = new FormData();
      params.append('uname', newAlias.value);
      params.append('email', newAddress.value);

      let res = await userJS._api.postAddAddress(params);
      if(res && res.success){

        let latestAddress = res.data[res.data.length-1];
        latestAddress.isSelected = false;
        latestAddress.isSaved = true;

        userEmailStore.emailData.push(latestAddress);
        userEmailStore.copiedEmailData.push(latestAddress);

        // 알림창 띄우기
        userAlertStore.$changeAlertInfo({
          Alias: latestAddress.alias,
          Address: latestAddress.address,
          status: 'email-added',
        });
        userAlertStore.$changeAlertFT('email', 'add');
      } else {
        console.warn('이메일 주소 추가하기 실패:', res?.msg || '응답 없음');
      }
    } catch (error) {
      console.error('이메일 주소 추가하는 중 오류 발생:', error);
    }

    setAddressOverlay(false); // 모달창 닫기
  };
  function setAddressOverlay(isOpen=true){// '추가' / '취소' 버튼
    isValidEmail.value = true;
    newAlias.value = '';
    newAddress.value = '';

    isAddAddressOverlayOn.value = isOpen;
  }
 // 북마크 이미지(ObjectURL) 캐시 & 중복요청 방지
 const bookmarkBlobMap = reactive({});  // { [baseUrl]: objectUrl }
 const inflightBookmarkSet = new Set(); // 요청 중복 방지

  // axios로 이미지 → blob 받아 ObjectURL 반환
  function bookmarkBlobSrc(baseUrl) {
    if (!baseUrl) return '';

    // 기존에 생성된 ObjectURL이 있으면 그대로 사용
    if (bookmarkBlobMap[baseUrl]) return bookmarkBlobMap[baseUrl];

    // 중복 요청 방지
    if (!inflightBookmarkSet.has(baseUrl)) {
      inflightBookmarkSet.add(baseUrl);

      // 캐시 무력화 파라미터(_=timestamp) 추가
      const bust = (baseUrl.includes('?') ? '&' : '?') + '_=' + Date.now();
      const requestUrl = baseUrl + bust;

      axios.get(requestUrl, {
        responseType: 'blob',
        withCredentials: true,    // 쿠키/세션 필요 시
      })
      .then(({ data: blob }) => {
        // 기존 ObjectURL 있으면 정리 후 교체
        if (bookmarkBlobMap[baseUrl]) {
          try { URL.revokeObjectURL(bookmarkBlobMap[baseUrl]); } catch {}
        }
        bookmarkBlobMap[baseUrl] = URL.createObjectURL(blob);
      })
      .catch(err => {
        console.error('bookmark image load failed:', err);
      })
      .finally(() => {
        inflightBookmarkSet.delete(baseUrl);
      });
    }

    // 첫 렌더에서는 아직 로드 전일 수 있으므로 빈 값
    return '';
  }

  // 컴포넌트 언마운트 시 ObjectURL 정리
  onBeforeUnmount(() => {
    Object.values(bookmarkBlobMap).forEach(objUrl => {
      try { URL.revokeObjectURL(objUrl); } catch {}
    });
  });

  /**
   * 주소록 : 이메일 주소 바로 삭제
   */
  const isInDeleteProgress = ref(false);
  async function removeAddress(seq){

    if (isInDeleteProgress.value) return;
    isInDeleteProgress.value = true;// 요청 진행 중

    let deletedEmail = userEmailStore.copiedEmailData.find(email => email.addressSeq == seq);

    // 기존 켜져있던 모든 alert창 끄기
    userAlertStore.$resetAllAlert();


    try {
      let params = new URLSearchParams();
      params.append('deviceKey', seq);

      let res = await userJS._api.deleteRemoveAddress(params);
      if(res && res.success){
        let email_index = userEmailStore.emailData.findIndex(email => email.addressSeq == seq);
        userEmailStore.emailData.splice(email_index, 1);

        // 받는 사람 div 영역에서 선택된 주소에서도 삭제하기.
        let selected_emailBook_index = userEmailStore.copiedSelectedEmailList_arr.findIndex(email => email.addressSeq == seq);
        if(selected_emailBook_index != -1) userEmailStore.copiedSelectedEmailList_arr.splice(selected_emailBook_index, 1);

        let emailBook_index = userEmailStore.copiedEmailData.findIndex(email => email.addressSeq == seq);
        userEmailStore.copiedEmailData.splice(emailBook_index, 1);
        userAlertStore.$changeAlertInfo({
          Alias: deletedEmail.alias || '',
          Address: deletedEmail.address,
          status: 'email-deleted',
        });
        userAlertStore.$changeAlertFT('email', 'delete');

      } else {
        console.warn('이메일 주소 삭제하기 실패:', res?.msg || '응답 없음');
      }
    } catch (error) {
      console.error('이메일 주소 삭제하는 중 오류 발생:', error);
    } finally {
      // 플래그를 리셋
      isInDeleteProgress.value = false;
    }
  }

  /**
   * 주소록 : '확인' 버튼 기능
   * API 호출이 아닌 선택한 '받는 사람' 이메일 배열만 수정되는 기능이다.
   */
  function applySelection(){
    userEmailStore.selectedEmailList_arr = [];
    userEmailStore.selectedEmailList_arr = JSON.parse(JSON.stringify(userEmailStore.copiedSelectedEmailList_arr));

    // 메일 전송 탭... '받는 사람' 입력창과 동기화 기능
    userEmailStore.selectedEmailList_str = [];
    userEmailStore.selectedEmailList_str = userEmailStore.selectedEmailList_arr
      .map(selection => !selection.isSaved ? selection.address : selection.alias ? `${selection.alias} <"${selection.address}">` : `<"${selection.address}">`);

    // MailSide.vue의 setSelectedEmailList() 함수에서 사용하는 변수
    userEmailStore.prevAddressLength = 0;
    userEmailStore.prevAddressLength = userEmailStore.selectedEmailList_str.length;

    closeEmailOverlay();
  }

  /**
   * 이메일-북마크 모달창 닫기 기능
   */
  function closeEmailOverlay() {
    userEmailStore.isEmailOverlayOn = false;
    searchText.value = '';
    isViewAll.value = true; // 검색 전 전체 목록 보여주기
    isSearchResultExist.value = // 초기화

    // 북마크 정보 열었을 때 사용한 변수들 값 초기화
    userEmailStore.isShowBookmark = false;
    userEmailStore.emailBookmarkImageUrl = '';
    userEmailStore.scrap = null;
  };

</script>

<style scoped>
::v-deep(.no-input-border .v-field--variant-outlined.v-field--focused .v-field__outline) {
  --v-field-border-width : 0px !important;
}
::v-deep(.email-search .v-input__control) {max-height: 36px;}
::v-deep(.email-search .v-input__control .v-field__field) {max-height: 36px;}
::v-deep(.email-search .v-input__control .v-field__append-inner) {max-height: 36px;}

::v-deep(.email-search .v-field--active) {border: 1px rgb(0, 0, 0, 0.87) solid !important; }
::v-deep(.email-search .v-field--appended) {padding-inline-end: 0 !important;}

::v-deep(.email-search input[type="text"]) {border: 0; padding: 0px; margin-left: 10px;}

.input-border-effect {
  border: 1px solid #ABABAB !important;
  border-radius: 4px;
  transition: border-color 0.5s ease;
}
.input-border-effect:hover, .input-border-effect:focus {
  border-color : rgb(0, 0, 0, 0.87) !important;
}
.v-theme--darkTheme .input-border-effect:hover,
.v-theme--darkTheme .input-border-effect:focus {
  border-color : white !important;
}
.input-border-effect.invalid-address-input:hover, .input-border-effect.invalid-address-input:focus {
  transition: border-color 0.1s ease;
  border-color : red !important;
}

.keyword-deletedGroup-border-effect {
  position: relative; /* 포지셔닝을 relative로 설정해서 오버레이를 그 안에 위치시키기 */
  border: 1px solid rgb(0, 0, 0, 0.87) !important;
  border-radius: 4px;
  transition: border-color 0.5s ease;
}
.keyword-deletedGroup-border-effect .overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(169, 169, 169, 0.6); /* 연한 회색 배경 */
  display: flex;
  justify-content: center;
  align-items: center;
  color: #fff;
  font-size: 16px;
  border-radius: 4px;
  z-index: 10;
}

/* 저장된 검색어 텍스트 */
.keyword-text-from-edit-group {
  white-space: normal; /* 기본적인 줄바꿈 허용 */
  word-wrap: break-word; /* 단어 단위에서 줄바꿈 */
  overflow-wrap: break-word; /* 영역 크기를 초과하면 줄바꿈 */
  word-break: break-word; /* 연속된 긴 문자열도 줄바꿈 */
  font-size: 14px;
  cursor: pointer;
}

::v-deep(.selected-saved-address-chip .mdi:before){
  color: #3182f6;
}
::v-deep(.selected-unsaved-address-chip .mdi:before){
  color: green;
}

/* 이메일  */
.invalid-address-input {
  border-color: red !important;
}
.invalid-address-error-text {
  display: block;
  color: red;
  font-size: 13px;
  margin-top: 4px;
  display: block;
}


</style>
